(() => {
  const formatMoney = (cents, format = 'Rs. {{amount}}') => {
    const value = (Number(cents || 0) / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return format.replace('{{amount}}', value).replace('{{amount_no_decimals}}', value.replace(/\.00$/, ''));
  };

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const selector = form.querySelector('[data-variant-select]');
    const button = form.querySelector('[data-add-to-cart]');
    const price = form.closest('[data-product-root]')?.querySelector('[data-product-price]');
    if (!selector || !button) return;

    selector.addEventListener('change', () => {
      const option = selector.options[selector.selectedIndex];
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.querySelector('span').textContent = available ? 'Add to cart' : 'Sold out';
      if (price && option.dataset.price) price.textContent = formatMoney(option.dataset.price, window.themeMoneyFormat);
      if (history.replaceState && option.value) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
      }
    });
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-copy-code]').forEach((button) => {
    button.addEventListener('click', async () => {
      const code = button.dataset.copyCode;
      try {
        await navigator.clipboard.writeText(code);
        const original = button.textContent;
        button.textContent = 'Copied';
        setTimeout(() => { button.textContent = original; }, 1400);
      } catch (_) {}
    });
  });

  const animated = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    animated.forEach((element) => observer.observe(element));
  } else {
    animated.forEach((element) => element.classList.add('is-visible'));
  }
})();
